import { cdnUrl } from "../../../../lib/cdn";
import { type OnyxConfig, ONYX_DEFAULTS } from "./config";

/**
 * Onyx görselleri için TEK boyutlandırma politikası.
 *
 * Kritik: hem `<img src>` render'ı hem de PremiumLayoutHost'un preload'u
 * (`collectMedia`) AYNI URL'i üretmeli. Aksi halde loader ham `/cdn/key`'i
 * ısıtırken bileşen `/cdn/key?w=1280` türevini ister → cache ıskası → lookbook'ta
 * kaydırırken görsel önce siyah gelip sonra "pat" diye belirir. Bu modül o tek
 * kaynağı tutar.
 *
 * Cloudflare Images whitelist genişlikleri: 64 / 480 / 800 / 1280 / 2048.
 */
export const ONYX_IMG_W = {
  look: 1280, // lookbook (yatay kaydırmada görünür — en kritik)
  split: 1280, // signature moment
  story: 1280, // hikaye portresi
  bg: 2048, // tam-ekran backdrop'lar (tarih / mekan)
} as const;

/** `/cdn/...` (gerçek düğün) → boyutlu WebP türevi; harici/demo URL'e dokunma. */
export function sizedUrl(url: string, w: number): string {
  return url.startsWith("/cdn/") ? cdnUrl(url, { w }) : url;
}

/**
 * Bileşenin RENDER edeceği tüm görsel URL'lerini (boyutlu + tekilleştirilmiş)
 * döndürür. `collectMedia` bununla preload eder → loader tam da ekranda
 * görünecek türevleri ısıtır, render'la birebir eşleşir.
 */
export function collectOnyxImages(
  config: OnyxConfig | undefined,
  galleryImages: string[],
): string[] {
  const cfg = config ?? ONYX_DEFAULTS;
  const pick = (idx: number) => galleryImages[idx] ?? galleryImages[0] ?? "";
  const urls: string[] = [];

  // Lookbook — l.imageUrl || galleryImages[0] (bileşendeki `looks` ile aynı)
  for (const l of cfg.lookbook.looks) {
    const u = l.imageUrl || galleryImages[0] || "";
    if (u) urls.push(sizedUrl(u, ONYX_IMG_W.look));
  }
  // Signature moment
  const split = pick(cfg.splitMoment.imageIndex);
  if (split) urls.push(sizedUrl(split, ONYX_IMG_W.split));
  // Story portresi + tarih backdrop'u AYNI kaynak index'i, İKİ farklı genişlik
  const story = pick(cfg.story.imageIndex);
  if (story) urls.push(sizedUrl(story, ONYX_IMG_W.story), sizedUrl(story, ONYX_IMG_W.bg));
  // Mekan backdrop'u
  const venue = pick(cfg.venue.imageIndex);
  if (venue) urls.push(sizedUrl(venue, ONYX_IMG_W.bg));

  return Array.from(new Set(urls.filter(Boolean)));
}
